import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const usePERIODIC_SERVICE_ORDERS_BY_STATUS_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'PERIODIC_SERVICE_ORDERS_BY_STATUS',
    name: t('widgets.periodicServiceOrdersByStatus.name'),
    description: t('widgets.periodicServiceOrdersByStatus.description'),
    color: 'darkGreen',
    icon: 'RiLineChartLine',
    categories: [t('widgets.periodicServiceOrdersByStatus.category')],
    previewWidth: '100%',

    initialState: {
      size: { width: 100, height: 400 },
      data: {
        presentation: 'line'
      }
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
